var magicStyles = [".static-page[data-v-5b4ccacb] {\n  margin: 0 auto;\n}\n.header[data-v-5b4ccacb] {\n  display: block;\n}\n.content[data-v-5b4ccacb] {\n  display: block;\n  margin: var(--magic-space--large, 32px) auto;\n}"];

export default magicStyles;
